let questionss = document.querySelectorAll(".questionss");

questionss.forEach(questionss => {
  questionss.addEventListener("click", event => {
    const active = document.querySelector(".questionss.active");
    
    if (active && active !== questionss) {
      active.classList.remove("active");
      active.nextElementSibling.style.maxHeight = 0;
    }

    questionss.classList.toggle("active");
    const answerss = questionss.nextElementSibling;

    if (questionss.classList.contains("active")) {
      answerss.style.maxHeight = answerss.scrollHeight + "px";
    } else {
      answerss.style.maxHeight = 0;
    }
  });
});


/* 🔥 DEFAULT OPEN FIRST */
if (questionss.length > 0) {
  questionss[0].classList.add("active");
  let firstAnswer = questionss[0].nextElementSibling;
  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
}